<ng-container *ngIf="inventoryItem">
	<ion-toolbar>
		<ion-title>
			<ion-text class="inventory-item__category">
				<span>{{ inventoryItem.categoryDesc }}</span>
				<span class="equip-name">: {{ inventoryItem.equipName }}</span>
			</ion-text>
		</ion-title>
	</ion-toolbar>
	<ion-grid class="inventory-item__details">
		<ion-row>
			<ion-col size="6" size-sm>
				<ion-label class="ion-text-wrap bold">
					ID:
				</ion-label>
			</ion-col>
			<ion-col size="6" size-sm>
				<ion-text class="bold">{{ inventoryItem.id }}</ion-text>
			</ion-col>
		</ion-row>
		<ion-row>
			<ion-col size="6" size-sm>
				<ion-label text-wrap
						   class="ion-text-wrap bold"
						   [innerHTML]="inventoryItem.attributes[0].name + ':'"></ion-label>
			</ion-col>
			<ion-col size="6" size-sm>
				<ion-text class="bold"
						  [innerHTML]="inventoryItem.attributes[0].value"></ion-text>
			</ion-col>
		</ion-row>

		<ion-row>
			<ion-col size="6" size-sm>
				<ion-label class="ion-text-wrap bold">
					Customer Service:
				</ion-label>
			</ion-col>
			<ion-col size="6" size-sm>
				<ion-text class="bold">{{ inventoryItem.customerServiceDescription }}</ion-text>
			</ion-col>
		</ion-row>


	</ion-grid>
</ng-container>
